// See: https://unpkg.com/browse/react-admin@5.1.3/docs/TranslationLocales.md
import {formalGermanMessages, informalGermanMessages} from '@haleos/ra-language-german'
import {merge} from 'lodash-es'

export default {
  ...merge(informalGermanMessages, formalGermanMessages, {
    ra: {
      action: {
        bulk_actions: "Ein Element ausgewählt |||| %{smart_count} Elemente ausgewählt",
        close: "Schließen",
        create_item: "Erstelle %{item}",
        move_down: "nach unten bewegen",
        move_up: "Nach oben bewegen",
        select_all: "Wählen Sie Alle",
        select_row: "Wählen Sie diese Zeile aus",
        update: "Update",
      },
      boolean: {
        // TODO: translate "ra.boolean.empty" should become "ra.boolean.null" to
        //  react-admin's default.
        empty: 'Leer',
      },
      input: {
        select: {
          emptyText: "Keiner",
        },
      },
      message: {
        bulk_update_content: "Sind Sie sicher, dass Sie diesen %{Name} aktualisieren " +
          "möchten? |||| Sind Sie sicher, dass Sie diese %{smart_count} Elemente " +
          "aktualisieren möchten?",
        bulk_update_title:
          "%{name} aktualisieren |||| Aktualisieren Sie %{smart_count} %{name}",
        error: "Es ist ein unerwarteter Fehler aufgetreten",
        file_upload_error: "Die Dateien konnten nicht hochgeladen werden. Bitte " +
          "versuchen Sie es erneut.",
        invalid_form: "Eingabefehler, bitte überprüfe Deine Eingaben",
      },
      notification: {
        created: "Element erfolgreich gelöscht",
        files_downloaded: "Datei heruntergeladen |||| Dateien heruntergeladen",
        item_doesnt_exist: "Es ist ein unerwarteter Fehler aufgetreten",
        not_authorized: "Sie sind nicht berechtigt, auf diese Ressource zuzugreifen.",
        updated: "Änderungen erfolgreich gespeichert",
      },
      page: {
        loading: "Flinkit wird geladen...",
      },
      sort: {
        ASC: "Aufsteigend",
        DESC: "Absteigend",
        sort_by: "Sortieren nach %{field} %{order}",
      },
    },
  }),
  actions: {
    apply: "Anwenden",
    cancel: "Abbrechen",
    chooseTemplate: "Template wählen",
    confirm: "Bestätigen",
    continue: "Weiter",
    delete: "Löschen",
    deleteAll: "Alle löschen",
    discard: "Verwerfen",
    download: "Herunterladen",
    forward: "Weiterleiten",
    logout: "Abmelden",
    moreInfo: "Mehr Info",
    open: "Öffnen",
    preview: "Vorschau",
    reply: "Antwort",
    resend: "Erneut senden",
    retry: "Erneut versuchen",
    select: "Wählen",
    send: "Senden",
    showInactiveFilters: "Filter",
  },
  advancedFiltering: {
    appliedFiltersButton: "Erweiterter Filter (%{count})",
    displayedFilters: {
      operator: "Bedingung",
      source: "Feld",
      value: "Wert",
    },
    logic: {
      and: "Und",
      or: "Oder",
    },
    openButtonTitle: "Erweiterten Filter hinzufügen",
    operators: {
      _eq: "Gleich",
      _ilike: "Enthält",
      _neq: "Ungleich",
    },
    title: "Erweiterter Filter",
  },
  ages: {
    today: "heute",
    yesterday: "gestern",
  },
  browserNotificationsProvider: {
    enableBrowserNotifications: "Aktiviere Browser-Benachrichtigungen von Flinkit",
    enableBrowserNotificationsButtonText: "Einfach hier klicken",
  },
  chat: {
    autoTranslationSettingButton: {
      autoDetection: "Automatische Erkennung und Übersetzung von eingehenden " +
        "Nachrichten.",
      doNotTranslate: "(Nicht übersetzen)",
      moreSettings: "Zusätzliche Einstellungen",
      subtitle: "Wähle eine Sprache aus, in die alle ausgehenden Nachrichten " +
        "automatisch für Deine Kunden übersetzt werden sollen. Diese Einstellung gilt " +
        "nur für den aktuellen Chat.",
      title: "Übersetzung",
    },
    chatAssignment: {
      unassigned: "Unzugewiesen",
    },
    chatList: {
      withoutText: "(Ohne Text)",
    },
    chatMessageBubble: {
      chatMessageFileAttachmentList: {
        chatMessageFileAttachment: {
          downloadAudioMessage: "<a>Laden Sie die Audiodatei herunter</a>, " +
            "um es zu spielen",
          locationChatMessageFileAttachment: {
            cannotShowGpsPosition: "Es tut uns leid, wir können die GPS-Position " +
              "gerade nicht anzeigen",
          },
          transcribedTextWarning: "Diese Nachricht wurde automatisch transkribiert:",
        },
      },
      originalMessageFrom: "Originalnachricht von",
      receivingErrorNotice: {
        generalMessage: "Eine nicht unterstützte WhatsApp-Nachricht wurde an Sie " +
          "gesendet",
      },
      repliedChatMessageBanner: {
        repliedMessageAuthoredByTheMerchantUserReading: "Du",
      },
      translationBanner: {
        translatedToDetectedLanguage: "%{language} automatisch übersetzt",
        translatedToTranslatedLanguages: "Automatisch übersetzt auf %{languages}",
      },
      unknownWhatsappMessageTypeText: "Der Nutzer hat möglicherweise versucht, ein " +
        "Dokument und einen Text in derselben Nachricht zu senden. Das Dokument und " +
        "der Text müssen in zwei separaten Nachrichten gesendet werden.",
      whatsappMessageStatus: {
        error: {
          couldNotReceiveMessage: "Nachricht konnte nicht empfangen werden " +
            "(Fehlercode: %{errorCode})",
          failedToSend: "Senden der Nachricht fehlgeschlagen (Fehlercode: %{errorCode})",
          failedToSendWithoutErrorCode: "Senden der Nachricht fehlgeschlagen",
          messageCouldNotBeCanceledOrSent: "Nachricht konnte nicht abgebrochen werden " +
            "oder gesendet",
        },
      },
    },
    chatMessageFileAttachmentListSidebar: {
      filters: {
        documents: "Dokumente",
        media: "Medien",
      },
      title: "Alle Medien",
    },
    chatMessageList: {
      index: {
        forward: "Weiterleiten an Teamchat",
        noText: "(Ohne Text)",
      },
    },
    compileChatMessageText: {
      emojiReactionText:
        "%{merchantCustomerUserName} hat mit %{emoji} auf \"%{messageText}\" reagiert",
    },
    external: {
      bulkActions: {
        archive: "Archivieren",
        success: "Chats aktualisiert",
        unarchive: "Wieder öffnen",
      },
      contextMenu: {
        addContact: "Kontakt hinzufügen",
        addFlag: "Chat markieren",
        archive: "Chat erledigt",
        archiveAndUnassign: "Archivieren & Nicht zugewiesen",
        editContact: "Kontakt bearbeiten",
        removeFlag: "Markierung entfernen",
        select: "Auswählen",
        spam: {
          confirm: "Bist Du sicher, dass Du diese Nummer blockieren möchtest? Du " +
            "kannst von dieser Nummer keine Nachrichten mehr empfangen",
          success: "Die Nummer wurde erfolgreich blockiert",
          title: "Nummer blockieren",
        },
        unarchive: "Chat wieder öffnen",
        unblock: "Nummer entsperren",
        viewAllMedia: "Alle Medien anzeigen",
        viewSummaries: "Zusammenfassungen anzeigen",
      },
      emptyChatNotification: {
        magicTemplate: "Zum Start einer Konversation wird deine Nachricht automatisch " +
          "als Template gesendet. Das kann bis zu 30 Minuten dauern.",
        normalTemplate: "Zum Start der Konversation kannst Du eine vorbereitete " +
          "<template>Template-Nachricht</template> senden.",
      },
      fileAttachment: "Dateianhang",
      filters: {
        all: "Alle",
        archived: "Erledigt",
        mine: "Meine",
        unassigned: "Nicht zugewiesen",
      },
      header: {
        blockedNumberTooltip: "Diese Nummer wurde blockiert",
        merchantCustomerUserSubtitle: {
          customerCodePrefix: "Kunden-Nr.",
        },
        saveContact: "Kontakt speichern",
      },
      templateMessage: "Template-Nachricht",
      title: "Eingang",
      toolbar: {
        audioRecorderTimeLimit: "Aufnahme pausiert, Sie können nur Sprachnachrichten " +
          "mit einer Länge von bis zu 5 Minuten aufnehmen",
        expiredReplyWindowNotification: {
          message: {
            magicTemplate: "Du bist außerhalb des 24-Stunden-Zeitraums, daher " +
              "wird deine Nachricht automatisch als Template gesendet. Das kann bis zu " +
              "30 Minuten dauern.",
            normalTemplate: "Das 24-Stunden-Antwortfenster ist abgelaufen. Du hast " +
              "jetzt die Möglichkeit, eine vorbereitete " +
              "<template>Template-Nachricht</template> oder einen " +
              "<file>Dateianhang</file> " +
              "zu versenden.",
          },
        },
      },
    },
    internal: {
      contextMenu: {
        archive: "Chat archivieren",
        editChat: "Chat bearbeiten",
        unarchive: "Chat wieder öffnen",
        viewAllMedia: "Alle Medien anzeigen",
      },
      filters: {
        all: "Alle",
        archived: "Archiviert",
      },
      productNewsChatTitle: "Flinkit News 🗞",
      title: "Teamchat",
    },
    notifications: {
      forwarded: "Nachricht weitergeleitet |||| Nachrichten weitergeleitet",
    },
    toolbar: {
      chatMessageTextFieldPlaceholder: "Ihre Nachricht",
      emojiPickerButton: {
        recent: "Aktuelle",
        search: "Suche",
        searchResults: "Suchergebnisse",
      },
      fileAttachment: {
        draggedFileRejected: "Datei kann nicht angehängt werden!",
        selectFromFiles: "Wählen Sie aus Dateien aus",
        selectImagesFromGallery: "Bilder aus Galerie auswählen",
        selectVideosFromGallery: "Videos aus Galerie auswählen",
      },
      translationPopper: {
        translatedInto: "Übersetzt in %{language}%{loadingDots}",
      },
    },
  },
  chat_message_template_placeholder_types: {
    FREE_TEXT: "Freitext",
    MERCHANT_CUSTOMER_USER_COMPANY_NAME: "Firma",
    MERCHANT_CUSTOMER_USER_FIRST_NAME: "Vorname",
    MERCHANT_CUSTOMER_USER_LAST_NAME: "Nachname",
    MERCHANT_CUSTOMER_USER_PLACEHOLDER: "Platzhalter",
    MERCHANT_CUSTOMER_USER_RESPONSIBLE_MERCHANT_USER_NAME: "Ansprechpartner",
  },
  chat_messages: {
    receivingErrorCode: {
      UNSUPPORTED_FILE_ATTACHMENT_MIME_TYPE: "Diese Nachricht enthält eine nicht " +
        "unterstützte angehängte Datei",
      WHATSAPP_MEDIA_UNDOWNLOADABLE: "Diese Nachricht enthält eine angehängte Datei, " +
        "die nicht heruntergeladen werden konnte",
    },
  },
  chatMessageTemplateBuilder: {
    templatePlaceholder: {
      errors: {
        labelRequired: "%{formattedLabel} muss ausgefüllt werden",
        maxLabelLength: "%{formattedLabel} darf %{maxLength} Zeichen nicht überschreiten",
      },
    },
  },
  chatMessageTemplateButtonList: {
    copyCodeCopiedToClipboard: "Kopiert: %{code}",
  },
  chatMessageTemplateEditor: {
    chatMessageTemplateField: {
      hideOptions: "Optionen ausblenden",
      seeAllOptions: "Alle Optionen anzeigen",
    },
    freeText: "Freitext",
    insertBlockButton: "Baustein einfügen",
    paperPreview: {
      buttons: "Buttons",
      links: "Links",
    },
    templateInput: {
      headlinePlaceholder: "Überschrift hier einfügen",
    },
  },
  components: {
    importButton: {
      exportInvalidRows: "Sie können die ignorierten Zeilen <link>exportieren</link> " +
        "um sie bei Bedarf anzupassen und sie dann erneut importieren.",
      status: {
        ignored: "%{invalidRowsCount} Zeilen wurden aufgrund folgender " +
          "Ursachen ignoriert:",
      },
    },
  },
  dialogs: {
    appUpdateAvailable: {
      button: "Jetzt App-Update installieren",
      message: "Eine neuere App-Version ist verfügbar. Bitte installiere zunächst das " +
        "Update um Flinkit ohne Einschränkungen nutzen zu können.",
    },
    channelSettings: {
      autoReplies: {
        absence: {
          endDate: "Enddatum",
          expired: "Abwesenheit abgelaufen",
          initialValue: "Hallo, ich habe deine Nachricht erhalten. Ich bin derzeit " +
            "abwesend, werde aber sofort nach meiner Rückkehr antworten.",
          invalidDatesOrder: "Enddatum kann nicht früher als Startdatum sein",
          invalidEndDate: "Enddatum erforderlich",
          invalidStartDate: "Startdatum erforderlich",
          startDate: "Startdatum",
          textInputLabel: "Dein Text",
          title: "Abwesend",
          toggleLabel: "Sende eine automatische Antwort, wenn sich dein Kunde bei dir " +
            "meldet, während du nicht erreichbar bist.",
        },
        chatBotSettingsMessageInputs: {
          templateLabel: "Select-Template",
          title: "Antworttyp wählen",
        },
        marketingOptIn: {
          textInputLabel: "Dein Text",
          title: "Marketing-Opt-in-Chatbot",
          toggleLabel: "Mit diesem Chatbot kannst Du die Zustimmung Deiner Kunden " +
            "einholen um Kampagnennachrichten zu empfangen",
        },
        marketingOptOut: {
          textInputLabel: "Dein Text",
        },
        noChatBotSetup: "Für diesen Kanal ist bisher kein Chatbot eingerichtet. Um " +
          "die Einrichtung zu starten schreibe einfach eine Mail an ",
        outsideWorkingHours: {
          initialValue: "Hallo und herzlich willkommen. Du erreichst uns außerhalb " +
            "unserer Geschäftszeiten. Wir melden uns schnellstmöglich bei Dir!",
          textInputLabel: "Dein Text",
          title: "Außerhalb der Öffnungszeiten",
          toggleLabel: "Sende Deinem Kunden eine automatische Antwort, wenn er " +
            "versucht, Dich außerhalb der Öffnungszeiten zu erreichen.",
        },
        permissionDenied: "Um Änderungen an den automatischen Antworten vorzunehmen, " +
          "wende Dich bitte an Deinen Admin.",
        title: "Auto-Antworten",
        welcome: {
          initialValue: "Guten Tag, deine Anfrage ist bei uns eingegangen und wir " +
            "werden uns schnellstmöglich bei dir zurückmelden. Viele Grüße.",
          textInputLabel: "Dein Text",
          title: "Willkommensnachricht",
          toggleLabel: "Sende Deinem Kunden eine automatische Willkommensnachricht " +
            "sobald er sich zum ersten Mal bei Dir meldet und du ihm bisher keine " +
            "Nachricht gesendet hast.",
        },
      },
      general: {
        membersListTitle: "Mitglieder",
        qrCode: {
          info: "Wenn deine Kunden diesen QR-Code scannen, gelangen sie direkt " +
            "zu diesem WhatsApp-Kanal. Teile ihn gerne mit ihnen.",
          shareViaEmailBody: "Klicken Sie auf diesen Link, landet man direkt in diesem " +
            "WhatsApp-Kanal%0D%0A" +
            "- teile ihn mit deinen Kunden%0D%0A" +
            "%{whatsappUrl}%0D%0A",
          title: "QR Code",
        },
        title: "Allgemein",
        whatsappAccountDisconnectionAlert: {
          connectAction: "Verbinde es mit Flinkit",
          currentConnection: "Derzeit verbunden mit: %{webhookHostname}",
          errorMessages: {
            INVALID_WHATSAPP_ACCOUNT: "Ungültiger Whatsapp-Account",
          },
          message: {
            disconnected: "Dein WhatsApp-Konto ist aktuell nicht mit Flinkit " +
              "verbunden und kann deshalb weder Nachrichten versenden noch empfangen",
            notReady: "Ihr WhatsApp-Konto ist noch nicht bereit und kann daher keine " +
              "Nachrichten senden oder empfangen",
          },
          successMessages: {
            connected: "Das WhatsApp-Konto wurde erfolgreich verbunden",
          },
        },
      },
      title: "Einstellungen",
      whatsappAccountBusinessProfile: {
        title: "WhatsApp-Profil",
      },
      workingHours: {
        closed: "Geschlossen",
        forbidden: "Um Änderungen an den Öffnungszeiten vorzunehmen, wende Dich" +
          "bitte an Deinen Admin.",
        from: "Von",
        subtitle: "Trage Deine Öffnungszeiten ein, damit Deine Kunden wissen, wann Du " +
          "erreichbar bist.",
        title: "Öffnungszeiten",
        to: "Bis",
      },
    },
    chatEdit: {
      editChatName: "Chatnamen bearbeiten",
      manageMembersTitle: "Chat-Mitglieder hinzufügen oder entfernen",
      renameInputPlaceholder: "Chat-Name",
      searchUsersInputPlaceholder: "Suche mit Name",
      title: "Chat bearbeiten",
    },
    chatSummaries: {
      empty: {
        subtitle: "Sie haben noch keine Zusammenfassungen",
        summarizeAction: "Chat zusammenfassen",
      },
      isSummarizingChat: "Chat-Nachrichten werden zusammengefasst...",
      subtitle: "Bleiben Sie informiert und erfassen Sie das Wesentliche Ihrer " +
        "Gespräche mit prägnanten Monatszusammenfassungen, maßgeschneiderten Titeln, " +
        "umsetzbaren Folgemaßnahmen sowie Indikatoren für potenzielle " +
        "Upselling-Möglichkeiten.",
      summariesLimitReached: "Sie können nur Zusammenfassungen von Nachrichten sehen, " +
        "die maximal 7 Monate alt sind.",
      summarizeNextMonth: "Holen Sie sich eine Zusammenfassung für den nächsten Monat",
      summarizePreviousMonth: "Zusammenfassung für den vorherigen Monat abrufen",
      summaryItem: {
        actionItem: "Aktionselement",
        copiedToClipboard: "In die Zwischenablage kopiert",
        customerSatisfaction: "Kundenzufriedenheit",
        customerSatisfactionMissing: "Für diesen Zeitraum konnte keine Rückschlüsse " +
          "auf die Kundenzufriedenheit gezogen werden",
        empty: "In diesem Zeitraum wurden keine Nachrichten ausgetauscht",
        subtitle: "%{title} (%{messagesCount} Nachrichten)",
        upsellPossibility: "Upselling-Möglichkeit",
        upsellPossibilityMissing: "Für diesen Zeitraum konnte keine " +
          "Upselling-Möglichkeit abgeleitet werden",
      },
      title: "Zusammenfassungen",
    },
    forwardChatMessages: {
      contacts: 'KONTAKTE',
      emptyChatsAndContacts: 'Keine Team-Chats oder Kontakte gefunden',
      teamChats: 'TEAM-CHATS',
      title: 'Nachricht weiterleiten an',
    },
    profile: {
      merchantUsersSettings: {
        accountDeletionButton: "Konto löschen",
        accountDeletionButtonError: "Fehler: %{message}",
        accountDeletionConfirm: "Möchtest Du Dein Nutzerkonto wirklich löschen?",
        thirdPartyConnections: {
          buttons: {
            hubspot: {
              synchronize: "Mit Hubspot synchronisieren",
            },
            microsoftDynamics: {
              synchronize: "Mit Microsoft Dynamics synchronisieren",
            },
            salesforce: {
              synchronize: "Mit Salesforce synchronisieren",
              synchronized: "Mit Salesforce synchronisiert",
            },
            sap: {
              synchronize: "Mit SAP synchronisieren",
            },
          },
          title: "Anbindungen",
        },
        title: "Profil Details",
        updateEmailAddress: {
          title: "Aktualisiere Email Adresse",
        },
      },
      sandbox: {
        title: "Start-Optionen",
      },
      title: "Profil",
    },
    startChat: {
      external: {
        inputPlaceholder: "Name oder Mobilfunknummer eingeben",
        subtitle: "Kontakt auswählen",
        title: "Chat öffnen",
      },
      internal: {
        actionButtonText: "Chat eröffnen",
        form: {
          chatName: {
            label: "Chat-Name",
          },
          teamMembers: {
            label: "Mitarbeiter wählen",
            placeholder: "Kollege",
          },
        },
        title: "Teamchat eröffnen",
      },
    },
    templateMessageComposer: {
      subtitle: "Templates sind bereits vorbereitete Nachrichten, die du jederzeit " +
        "versenden kannst.",
      templateBuilder: {
        chooseTemplate: "Template wählen",
        fillPlaceholder: "Platzhalter ausfüllen",
      },
      title: "Template Nachrichten",
    },
    thirdPartyConnection: {
      failed: "Verbindung fehlgeschlagen",
      loading: "Verbindung wird abgeschlossen...",
      success: "Verbindung erfolgreich",
    },
  },
  errors: {
    codes: {
      EMAIL_ADDRESS_NOT_FOUND: "Die E-Mail-Adresse wurde nicht gefunden",
    },
    unknown: "Es ist ein unbekannter Fehler aufgetreten.",
  },
  extendedList: {
    selectAllPages: "Wählen Sie alle Seiten aus",
  },
  hooks: {
    useBrowserNotifications: {
      notificationTitle: "Neue Benachrichtigung",
    },
    useTakePicture: {
      promptLabelCancel: "Abbrechen",
      promptLabelHeader: "Bild",
      promptLabelPhoto: "Von Fotos",
      promptLabelPicture: "Von Kamera",
    },
    useUserDisplayName: {
      channelChatBotUser: "🤖 Automatische Antwort",
    },
  },
  languages: {
    // Extracted from https://de.wikipedia.org/w/index.php?title=Liste_der_ISO-639-1-Codes
    'aa': "Afar",
    'ab': "Abchasisch",
    'ae': "Avestisch",
    'af': "Afrikaans",
    'ak': "Akan",
    'am': "Amharisch",
    'an': "Aragonesisch",
    'ar': "Arabisch",
    'as': "Assamesisch",
    'av': "Avarisch",
    'ay': "Aymara",
    'az': "Aserbaidschanisch",
    'ba': "Baschkirisch",
    'be': "Belarussisch",
    'bg': "Bulgarisch",
    'bh': "Bihari",
    'bi': "Bislama",
    'bm': "Bambara",
    'bn': "Bengalisch",
    'bo': "Tibetisch",
    'br': "Bretonisch",
    'bs': "Bosnisch",
    'ca': "Katalanisch",
    'ce': "Tschetschenisch",
    'ch': "Chamorro",
    'co': "Korsisch",
    'cr': "Cree",
    'cs': "Tschechisch",
    'cu': "Kirchenslawisch",
    'cv': "Tschuwaschisch",
    'cy': "Walisisch",
    'da': "Dänisch",
    'de': "Deutsch",
    'dv': "Dhivehi",
    'dz': "Dzongkha",
    'ee': "Ewe",
    'el': "Griechisch",
    'en': "Englisch",
    'eo': "Esperanto",
    'es': "Spanisch",
    'et': "Estnisch",
    'eu': "Baskisch",
    'fa': "Persisch",
    'ff': "Fulfulde",
    'fi': "Finnisch",
    'fj': "Fidschi",
    'fo': "Färöisch",
    'fr': "Französisch",
    'fy': "Westfriesisch",
    'ga': "Irisch",
    'gd': "Schottisch-gälisch",
    'gl': "Galicisch",
    'gn': "Guaraní",
    'gu': "Gujarati",
    'gv': "Manx-Gälisch",
    'ha': "Hausa",
    'he': "Hebräisch",
    'hi': "Hindi",
    'ho': "Hiri Motu",
    'hr': "Kroatisch",
    'ht': "Haitianisch",
    'hu': "Ungarisch",
    'hy': "Armenisch",
    'hz': "Otjiherero",
    'ia': "Interlingua",
    'id': "Indonesisch",
    'ie': "Interlingue",
    'ig': "Igbo",
    'ii': "Yi",
    'ik': "Inupiaq",
    'io': "Ido",
    'is': "Isländisch",
    'it': "Italienisch",
    'iu': "Inuktitut",
    'ja': "Japanisch",
    'jv': "Javanisch",
    'ka': "Georgisch",
    'kg': "Kikongo",
    'ki': "Kikuyu",
    'kj': "oshiKwanyama",
    'kk': "Kasachisch",
    'kl': "Grönländisch",
    'km': "Khmer",
    'kn': "Kannada",
    'ko': "Koreanisch",
    'kr': "Kanuri",
    'ks': "Kashmiri",
    'ku': "Kurdisch",
    'kv': "Komi",
    'kw': "Kornisch",
    'ky': "Kirgisisch",
    'la': "Latein",
    'lb': "Luxemburgisch",
    'lg': "Luganda",
    'li': "Limburgisch",
    'ln': "Lingála",
    'lo': "Laotisch",
    'lt': "Litauisch",
    'lu': "Kiluba",
    'lv': "Lettisch",
    'mg': "Malagassi",
    'mh': "Marshallesisch",
    'mi': "Maori",
    'mk': "Mazedonisch",
    'ml': "Malayalam",
    'mn': "Mongolisch",
    'mr': "Marathi",
    'ms': "Malaiisch",
    'mt': "Maltesisch",
    'my': "Birmanisch",
    'na': "Nauruisch",
    'nb': "Bokmål",
    'nd': "Nord-Ndebele",
    'ne': "Nepali",
    'ng': "Ndonga",
    'nl': "Niederländisch",
    'nn': "Nynorsk",
    'no': "Norwegisch",
    'nr': "Süd-Ndebele",
    'nv': "Navajo",
    'ny': "Chichewa",
    'oc': "Okzitanisch",
    'oj': "Ojibwe",
    'om': "Oromo",
    'or': "Oriya",
    'os': "Ossetisch",
    'pa': "Panjabi",
    'pi': "Pali",
    'pl': "Polnisch",
    'ps': "Paschtunisch",
    'pt': "Portugiesisch",
    'qu': "Quechua",
    'rm': "Romanisch",
    'rn': "Kirundi",
    'ro': "Rumänisch",
    'ru': "Russisch",
    'rw': "Ruandisch",
    'sa': "Sanskrit",
    'sc': "Sardisch",
    'sd': "Sindhi",
    'se': "Nordsamisch",
    'sg': "Sango",
    'sh': "Serbokroatisch",
    'si': "Singhalesisch",
    'sk': "Slowakisch",
    'sl': "Slowenisch",
    'sm': "Samoanisch",
    'sn': "Shona",
    'so': "Somali",
    'sq': "Albanisch",
    'sr': "Serbisch",
    'ss': "Siswati",
    'st': "Sesotho",
    'su': "Sundanesisch",
    'sv': "Schwedisch",
    'sw': "Swahili",
    'ta': "Tamil",
    'te': "Telugu",
    'tg': "Tadschikisch",
    'th': "Thai",
    'ti': "Tigrinya",
    'tk': "Turkmenisch",
    'tl': "Tagalog",
    'tn': "Setswana",
    'to': "Tongaisch",
    'tr': "Türkisch",
    'ts': "Xitsonga",
    'tt': "Tatarisch",
    'tw': "Twi",
    'ty': "Tahitisch",
    'ug': "Uigurisch",
    'uk': "Ukrainisch",
    'ur': "Urdu",
    'uz': "Usbekisch",
    've': "Tshivenda",
    'vi': "Vietnamesisch",
    'vo': "Volapük",
    'wa': "Wallonisch",
    'wo': "Wolof",
    'xh': "isiXhosa",
    'yi': "Jiddisch",
    'yo': "Yoruba",
    'za': "Zhuang",
    'zh': "Chinesisch",
    'zu': "Zulu",
  },
  pages: {
    companyDetails: {
      button: "Jetzt loslegen",
      inputs: {
        companyName: {
          label: "Unternehmen",
          placeholder: "Unternehmensname",
        },
        companySize: {
          label: "Größe",
          options: {
            '1-10': "1 bis 10 Mitarbeiter",
            '11-50': "11 bis 50 Mitarbeiter",
            '51-200': "51 bis 200 Mitarbeiter",
            '201-500': "201 bis 500 Mitarbeiter",
            '500+': "Mehr als 500 Mitarbeiter",
          },
          placeholder: "Unternehmensgröße wählen",
        },
        industry: {
          label: "Branche",
          options: {
            AUTOMOTIVE: "Automobil",
            CONSTRUCTION: "Bauwesen",
            DIGITAL_AGENCY: "Digitale Agentur",
            EDUCATION_SERVICES: "Bildungsdienstleistungen",
            GOVERNMENT: "Regierung und öffentlicher Sektor",
            HEALTHCARE: "Gesundheitswesen",
            HOTELS: "Hotel, Restaurants & Freizeit",
            HOUSEHOLD: "Haushaltswaren & Dienstleistungen",
            INSURANCE: "Versicherung",
            ONLINE_MARKETPLACES: "Online-Marktplätze & SaaS-Plattformen",
            OTHER: "Andere",
            PROFESSIONAL_SERVICES: "Professionelle Dienstleistungen",
          },
          placeholder: "Branche auswählen",
        },
      },
      subtitle: "Vervollständige deine Angaben, um loszulegen.",
      title: "🎉 Konto erfolgreich erstellt",
      trustedCompaniesTitle: "Führende Unternehmen setzen auf Flinkit",
    },
    companySettings: {
      tabs: {
        addNumbersAndMerchantUsers: {
          contactsVisibility: {
            title: "Kontakte-Sichtbarkeit",
          },
          createMerchantUser: {
            restrictContactGroups: "Benutzer auf Kontaktgruppen beschränken",
            subtitle: "Einen neuen Benutzer erstellen oder Benutzer gesammelt " +
              "importieren.",
            title: "Neuen Benutzer hinzufügen",
          },
          createNumber: {
            subtitle: "Neu hinzugefügte Nummern sind sofort in Kanälen sichtbar.",
            title: "Neue Nummer hinzufügen",
            whatsappConnectionButton: "Neue WhatsApp-Nummern verbinden",
          },
          faq: {
            linkText: "Finde hier",
            text: "Hilfe und Antworten auf häufig gestellte Fragen zur Einrichtung von " +
              "Flinkit.",
          },
          title: "Nummern und Benutzer hinzufügen",
        },
        channels: {
          addAdmins: "Add Admins",
          addUsers: "Add users",
          admins: "Admins",
          apply: "Übernehmen",
          removeAll: "Alle entfernen",
          title: "Kanäle",
          users: "Users",
        },
        merchantUsersManagement: {
          title: "Benutzer",
        },
        tagsManagement: {
          title: "Tags",
        },
      },
      title: "Firmeneinstellungen",
    },

    login: {
      button: "Einloggen",
      errors: {
        UNAUTHORIZED_USER: "Ungültige E-Mail-Adresse und/oder Passwort",
        UNEXPECTED_AUTH_ERROR: "Unerwarteter Authentifizierungsfehler",
      },
      inputs: {
        emailAddress: {
          label: "Email-Adresse",
          placeholder: "johndoe@doe.de",
        },
        password: {
          label: "Passwort",
          placeholder: "Geben Sie Ihr Passwort ein",
        },
      },
      links: {
        forgotPassword: "Passwort vergessen? <forgot>Zurücksetzen</forgot>",
        signup: "Noch kein Konto? <signup>Registriere dich jetzt</signup>",
      },
      title: "👋 Willkommen zurück",
    },
    notFound: {
      message: "Entschuldigung, wir können die von Ihnen gesuchte Seite nicht finden!",
      title: "Seite nicht gefunden",
    },
    requestPasswordReset: {
      inputs: {
        emailAddress: {
          label: "Email-Adresse",
          placeholder: "johndoe@doe.de",
        },
      },
      login: "Zurück zum <login>Einloggen</login>",
      register: "Noch kein Konto? <register>Registriere dich jetzt.</register>",
      resetRequestSent: {
        login: "Zurück zum Login",
        resend: "Nicht da? <link>E-Mail erneut senden</link>",
        subtitle: "Eine E-Mail mit Anweisungen wurde an deinen Posteingang gesendet.",
        title: "📬 Überprüfe deinen E-Mail-Posteingang",
        warn: "Falls du keine E-Mail erhältst, überprüfe bitte deinen Spam-Ordner.",
      },
      submit: "Zurücksetzen",
      title: "Passwort zurücksetzen",
    },
    resetPassword: {
      errors: {
        INVALID_PASSWORD_RESET_CODE: "Die Anfrage zum Zurücksetzen des Passworts ist " +
          "abgelaufen. Bitte fordern Sie ein neues Zurücksetzen des Passworts an",
      },
      fields: {
        newPassword: {
          label: "Neues Passwort",
          placeholder: "Geben Sie mindestens 8 Zeichen ein",
        },
        repeatNewPassword: {
          label: "Geben Sie das neue Passwort erneut ein",
          placeholder: "Geben Sie mindestens 8 Zeichen ein",
        },
      },
      login: "Erinnern Sie sich an Ihr Passwort? <login>Einloggen</login>",
      passwordRequirements: {
        digit: "Mindestens eine Nummer",
        length: "Mindestens 8 Zeichen",
        lowercase: "Mindestens ein Kleinbuchstabe",
        uppercase: "Mindestens ein Großbuchstabe",
      },
      passwordResetSuccess: {
        login: "Zurück zum Login",
        nextStep: "Verwende dein neues Passwort, um dich einzuloggen",
        subtitle: "Dein Passwort wurde erfolgreich geändert.",
        title: "🎉 Passwort erfolgreich geändert",
      },
      register: "Noch kein Konto? <register>Registriere dich jetzt.</register>",
      title: "Neues Passwort eingeben",
      validations: {
        newPasswordRepeat: "Passwort und Passwortbestätigung stimmen nicht überein",
      },
    },
    salesforceAuthentication: {
      connectionError: "Dein Salesforce-Konto konnte noch nicht mit Flinkit verbunden " +
        "werden",
      connectionSuccess: "Dein Salesforce-Konto ist nun mit Flinkit verbunden",
    },
    sandbox: {
      subtitle: "Wie möchtest du loslegen?",
      title: "👋 Willkommen %{firstName}",
    },
    signup: {
      button: "Kostenloses Konto erstellen",
      errors: {
        MERCHANT_USER_EXISTS: "Ein anderer Benutzer mit dieser " +
          "E-Mail-Adresse existiert bereits",
      },
      inputs: {
        emailAddress: {
          label: "Geschäfts-E-Mail Adresse",
          placeholder: "mustermann@acme.de",
        },
        fullName: {
          label: "Vor- und Nachname",
          placeholder: "z.B. Max Mustermann",
        },
        password: {
          label: "Passwort",
          placeholder: "Gib mindestens 8 Zeichen ein.",
        },
      },
      links: {
        forgotPassword: "Passwort vergessen? <forgot>Zurücksetzen.</forgot>",
        login: "Bereits ein Konto? <login>Einloggen</login>",
      },
      title: "Kostenloses Konto erstellen",
    },
    startExternalChat: {
      embeddedExternalChatPage: {
        openInFlinkit: "In Flinkit öffnen",
      },
      selectChannel: "Bitte wählen Sie einen Kanal:",
    },
    whatsappChannelsConnection: {
      connectionError: "Dein WhatsApp-Konto konnte noch nicht verbunden werden",
      connectionSuccess: "Dein WhatsApp-Konto ist nun mit Flinkit verbunden",
      errorCodes: {
        CHANNEL_PERMISSION_NOT_GRANTED: "Fehlende Berechtigung. Bitte gewähren Sie " +
          "Flinkit die Berechtigung zur Verwaltung der folgenden Kanäle: " +
          "<strong>%{channelIdentifiers}</strong>",
        CONNECTING_ON_PREMISE_NUMBER_UNSUPPORTED: "Die folgenden Kanäle werden noch " +
          "lokal gehostet, was derzeit nicht unterstützt wird. Bitte migrieren Sie zur " +
          "Cloud-API-Hosting: <strong>%{channelIdentifiers}</strong>",
        THREE_SIXTY_CHANNEL_METADATA_ERROR: "Es kann keine Verbindung zum " +
          "WhatsApp-Konto hergestellt werden, da die relevanten Kanalmetadaten von " +
          "360dialog für channel_identifiers=<strong>%{channelIdentifiers}</strong> " +
          "nicht abgerufen werden konnten.",
        THREE_SIXTY_CHANNEL_NOT_FOUND: "Die folgenden Kanäle wurden auf 360dialog " +
          "nicht gefunden: <strong>%{channelIdentifiers}</strong>",
        UNEXPECTED: "Aus einem unerwarteten Grund konnten die Kanäle nicht verbunden " +
          "werden. Bitte versuchen Sie es erneut: <strong>%{channelIdentifiers}</strong>",
      },
    },
  },
  periods: {
    month: "Diesen Monat",
    recent: "Kürzlich",
  },
  resources: {
    campaigns: {
      action: {
        create: "Neue Kampagne",
      },
      audienceTypeChoices: {
        ALL: "Alle Kontakte",
        ALL_WITH_MARKETING_OPT_IN: "Alle Kontakte mit Opt-in",
        SELECTED_CUSTOMER_USERS: "Einzelauswahl",
      },
      create: {
        createAction: "Weiter",
        error: "Fehler beim Erstellen der Kampagne",
        inputs: {
          audienceType: {
            subtitle: "An welchen Kundenkreis soll diese Kampagne gesendet werden?",
          },
          channelId: {
            label: "Kanal",
            subtitle: "Von welchem Kanal aus soll diese Kampagne versendet werden",
          },
          chatMessageTemplateId: {
            label: "Wähle ein Template",
            subtitle: "Um eine Kampagne erstellen zu können benötigst du ein " +
              "freigegebenes Kampagnen Template",
          },
          name: {
            subtitle: "Dieser Name dient ausschließlich internen Zwecken und wird dem " +
              "Kunden nicht angezeigt.",
          },
          scheduledTimestamp: {
            label: "Datum und Uhrzeit",
            subtitle: "Lege das Datum und die Uhrzeit fest, zu der die Kampagne " +
              "geschaltet werden soll",
          },
          templateButtonParameterFields: {
            copyCode: {
              couponCode: {
                title: "Gutscheincode",
              },
              title: "Button-Text",
            },
            url: {
              text: {
                title: "Button-Text",
              },
              url: {
                label: "Bsp.: Seite-123",
                title: "Eingabe für: <strong>%{buttonUrl}</strong>",
              },
            },
          },
        },
        success: "Kampagne erfolgreich erstellt",
        templateButtonParameterFields: {
          title: "Dynamische Buttons",
          url: {
            title: "Website besuchen",
          },
        },
        toolbar: {
          confirmDialog: {
            emptyContacts: "Noch kein Kontakt ausgewählt",
            instantCampaignMessage: "Deine Kampagne mit dem Namen " +
              "“<strong>%{name}</strong>“ wird “<strong>sofort</strong>“ an diese " +
              "Kontakte gesendet.",
            scheduledCampaignMessage: "Deine Kampagne mit dem Namen " +
              "“<strong>%{name}</strong>“ wird " +
              "“<strong>am %{scheduledDatetime}</strong>“ an diese Kontakte gesendet.",
            termsAndConditions: "Durch das Senden bestätigst Du, dass Du die " +
              "Bedingungen für den WhatsApp-Newsletter-Versand zur Kenntnis genommen " +
              "hast.",
            title: "Kampagne senden",
          },
        },
      },
      createFormTitle: "Kampagnen erstellen",
      createTemplate: "Neues Template anlegen",
      createTemplateDialog: {
        confirmationText: "Weiter zu Templates",
        content: "Du wirst zur Template-Erstellung weitergeleitet, deine aktuelle " +
          "Kampagne wird nicht gespeichert.",
      },
      createTemplateLabel: "Beginnen Sie mit der Eingabe, um eine neue Vorlage zu " +
        "erstellen",
      empty: "Du hast bisher noch keine Kampagnen erstellt",
      fields: {
        audienceType: "Kunden-Zielgruppe",
        channelId: "Kampagnen-Kanal",
        chatMessageTemplateId: "Kampagnen-Template",
        deliveredMessageCount: "Geliefert an",
        insertionTimestamp: "Erstellt um",
        insertionUserId: "Gesendet von",
        name: "Name der Kampagne",
        readMessageCount: "Gelesen von",
        scheduledTimestamp: "Zeitplan",
        sentTimestamp: "Gesendet",
        totalMessageCount: "Gesendet an",
      },
      invite: "Starte doch jetzte eine neue Kampagne!",
      list: {
        description: "Über eine Kampagne hast du die Möglichkeit, mehreren Kontakte " +
          "gleichzeitig eine Nachricht zu schreiben, um beispielsweise Newsletter und " +
          "Informationen zu neuen Produkten & Angeboten zu versenden.",
        description2: "Um eine Kampagne zu starten benötigst du ein freigegebenes " +
          "Kampagnen-Template.",
      },
      name: "Kampagnen",
      show: {
        campaignPerformanceSubtitle:
          "Die Prozentzahl zeigt das Verhältnis von Stufe zu Stufe.",
        campaignPerformanceTitle: "Kampagnen-Performance",
        confirmDelete: "Sind Sie sicher, dass Sie diese Kampagne löschen möchten?",
        exportMessageMetadata: {
          errors: {
            ONGOING_CAMPAIGN: "Informationen zur Kampagnennachricht können nicht " +
              "exportiert werden, da diese Kampagne noch läuft. Bitte warten Sie, bis " +
              "es fertig ist.",
            PENDING_CAMPAIGN: "Informationen zur Kampagnennachricht können nicht " +
              "exportiert werden, da diese Kampagne noch nicht gestartet wurde.",
          },
        },
        fields: {
          audienceType: "Gesendet an:",
          scheduledFor: "Geplant für",
          sentOn: "Gesendet am",
        },
        templatePreview: {
          label: "Benutztes Template",
        },
      },
    },
    channel_chat_bot_users: {
      fields: {
        optInTriggerAutoresponseText: "Opt-In Nachricht",
        optOutTrigger: "Opt-Out Trigger",
        optOutTriggerAutoresponseText: "Opt-Out Bestätigungsantwort",
      },
      title: "Opt-In Chatbot-Einstellungen",
    },
    channel_merchant_users: {
      action: {
        messages: {
          channelAdded: "Kanal hinzugefügt",
          removed: "Kanalhändlerbenutzer gelöscht",
        },
      },
      import: {
        button: "Kanalnutzer importieren",
        confirm: "Möchten Sie alle Kanalnutzer aus dieser Datei importieren " +
          "\"%{filename}\"?",
        error: "Leider konnte die Kanalnutzer-Datei nicht importiert werden." +
          "Bitte kontaktieren Sie unseren Kundenservice unter support@flinkit.de. " +
          "Fehlermeldung: %{message}",
        exportInvalidRows: "Sie können die ignorierten Zeilen " +
          "<link>exportieren</link>, um sie bei Bedarf anzupassen und anschließend " +
          "erneut zu importieren.",
        progressDialog: {
          progressMessage: "Ihre Kanalnutzer-Datei wird importiert. Bitte geben Sie " +
            "uns einen Moment...",
          title: "Kanalnutzer importieren",
        },
        status: {
          ignored: "%{invalidRowsCount} Zeilen wurden aus folgenden Gründen ignoriert:",
        },
        success: "%{importedChannelMerchantUsersCount} Kontakte wurden erfolgreich " +
          "importiert oder aktualisiert.",
      },
      importRowFailureReasons: {
        CHANNEL_PHONE_NUMBER_NOT_FOUND: "Für einige Telefonnummern wurde kein Kanal " +
          "gefunden",
        INVALID_ROW: "Einige Zeilen sind ungültig",
        MERCHANT_USER_EMAIL_ADDRESS_NOT_FOUND: "Für einige E-Mail-Adressen wurde kein " +
          "Nutzer gefunden",
      },
    },
    channels: {
      edit: {
        inputs: {
          name: {
            label: "Kanal (%{phoneNumber})",
            subtitle: "Name dieses Kanals",
          },
        },
      },
    },
    chat_message_templates: {
      action: {
        create: "Neues Template",
        delete: "Template löschen",
      },
      confirmDeletion: "Möchtest Du dieses Template wirklich löschen?",
      create: {
        buttonTypes: {
          COPY_CODE: 'Angebotscode kopieren',
          PHONE_NUMBER: 'Telefonnummer anrufen',
          QUICK_REPLY: 'Schnelle Antwort',
          URL: 'Webseite besuchen',
        },
        buttonURLTypes: {
          DYNAMIC: 'Dynamisch',
          STATIC: 'Statisch',
        },
        contentCard: {
          header: {
            media: {
              uploadButtonText: {
                document: "Laden Sie eine PDF-Datei hoch",
                image: "JPG- oder PNG-Datei hochladen",
                video: "Laden Sie eine MP4-Datei hoch",
              },
            },
            title: "Kopfzeile hinzufügen",
            types: {
              DOCUMENT: "Dokument",
              IMAGE: "Bild",
              NONE: "Keine",
              TEXT: "Text",
              VIDEO: "Video",
            },
          },
          subtitle: "Füllen Sie Kopfzeile, das Textfeld und die Fußzeile Ihres " +
            "Templates aus",
          title: "Inhalt",
        },
        createButton: "Template einreichen",
        error: "Fehler beim Erstellen des Templates",
        imageRequiredForHeaderMediaSwitch: "Falls der Schalter „Bild hinzufügen“ " +
          "aktiviert ist, muss ein Bild definiert werden",
        inputs: {
          body: {
            label: "Text hier eingeben",
            title: "Textfeld",
            validations: {
              consecutiveSpaces: "Mehr als 4 aufeinanderfolgende Leerzeichen sind " +
                "nicht erlaubt",
              freeTextNotAllowedInCampaignTemplate: "'{{Freitext}}' Bausteine werden " +
                "in einem Marketing Template nicht unterstützt",
              placeholdersNotAllowedAtStartOrEnd: "Platzhalter dürfen nicht am Anfang " +
                "oder Ende eines Templates stehen",
              tabs: "Tabellierungen sind nicht erlaubt",
            },
          },
          buttons: {
            buttonTextTitle: "Button Text",
            buttonType: {
              emptyText: "Kein",
              label: "Button hinzufügen",
            },
            copyCodeExample: {
              label: "Code eingeben",
              title: "Beispiel Angebotscode",
            },
            phoneNumber: {
              countryCode: {
                label: "Country",
              },
              phoneNumber: {
                label: "Telefonnummer anrufen",
              },
              text: {
                label: "Button-Text",
              },
            },
            quickReply: {
              label: "Schnellantworten",
              validations: {
                duplication: "Sie können nicht denselben Text für mehrere Schnelle " +
                  "Antwort Buttons verwenden",
              },
            },
            subtitle: "Erstellen Sie Buttons, mit denen Kunden auf Ihre Nachricht " +
              "antworten oder eine Aktion ausführen können. Sie können bis zu 10 " +
              "Buttons hinzufügen. Ab dem 4. Button werden diese in einer " +
              "aufklappbaren Liste angezeigt.",
            title: "Button (Optional)",
            url: {
              parameterExample: {
                label: "Beispiel für URL-Parameter",
                subLabel: "Endgültige Form der URL: <url>%{buttonUrl}</url>",
                tip: "Fügen Sie zur Überprüfung des Templates bitte einen Beispielwert " +
                  "für {{1}} ein. Verwenden Sie keine echten Kundendaten.",
                title: "Beispiel zum Hinzufügen eines URL-Parameters",
              },
              text: {
                label: "Button-Text",
              },
              type: {
                label: 'Typ der URL',
              },
              url: {
                label: "Button-URL",
              },
            },
          },
          footer: {
            label: "Text eingeben",
            title: "Fußzeile (Optional)",
          },
          name: {
            label: "Template Name",
          },
          type: {
            label: "Auswählen",
          },
        },
        nameSubtitle: "Dieser Name dient ausschließlich internen Zwecken und wird dem " +
          "Kunden nicht angezeigt.",
        success: "Template erfolgreich erstellt",
        templatePreviewTitle: "Template Vorschau",
        title: "Template erstellen",
        typeSubtitle: "Kampagnen Templates sind ausschließlich für Marketing Maßnahmen " +
          "vorgesehen",
      },
      createFormTitle: "Template erstellen",
      description: "Durch individuelle Templates kannst Du flexibel und bequem mit " +
        "Deinen Kunden kommunizieren.",
      empty: "Noch keine Templates vorhanden",
      errorMessages: {
        INVALID_PLACEHOLDER_NAME: "Mindestens ein Platzhalter hat einen ungültigen Namen",
        TEMPLATE_ALREADY_EXISTS:
          "Ein anderes Template existiert bereits mit diesem Namen",
        VIDEO_HEADER_MEDIA_CODEC_NOT_SUPPORTED: "Der ausgewählte Header-Videocodec " +
          "wird nicht unterstützt. Es kann nur der H.264-MP4-Videocodec verwendet " +
          "werden. Aktueller Codec: \"%{codec}\"",
      },
      fields: {
        approvalStatus: "Freigabe",
        category: "Art",
        language: "Sprache",
        name: "Name",
        status: "Status",
        text: "Nachricht",
        type: "Art",
      },
      invite: "Neues erstellen",
      name: "Templates",
      startCampaign: "Neue starten",
      types: {
        MARKETING: "Kampagne",
        UTILITY: "Standard",
      },
    },
    chat_messages: {
      name: "Nachrichten",
      search: {
        empty: "Keine Ergebnisse gefunden. Bitte Suchbegriff überprüfen.",
      },
    },
    chats: {
      empty: "Dein Posteingang ist leer",
      invite: "Starte doch jetzt einen Chat mit Deinen Kunden!",
    },
    contactGroups: {
      name: "Kontaktgruppen",
    },
    customer_users: {
      fields: {
        whatsappDisplayName: "WhatsApp-Name",
        whatsappPhoneNumber: "Telefonnummer",
      },
    },
    merchant_customer_users: {
      action: {
        create: "Neuen Kontakt anlegen",
        seeChat: "Zum Chat",
      },
      create: {
        company: "Firma",
        error: "Fehler beim Erstellen des Kontakts",
        inputs: {
          whatsappPhoneNumber: {
            helperText: "Format: +493028874362",
          },
        },
        internal: "Intern",
        personalData: "Persönliche Daten",
        success: "Neuer Kontakt erfolgreich erstellt",
      },
      createFormTitle: "Kontakt anlegen",
      edit: {
        addTag: "Tag hinzufügen",
        channelTags: "Kanal Tags",
        company: "Firma",
        confirmDeletion: "Möchtest Du diesen Kontakt wirklich löschen?",
        createTagPopupButton: "Neuen Tag erstellen",
        emptyChannelTags: "Bisher ohne Kanal-Tags",
        internal: "Intern",
        personalData: "Persönliche Daten",
        title: "Kontaktdetails",
      },
      empty: "Keinen Kontakt gefunden",
      errorMessages: {
        chatLink: "Der Chat konnte nicht erstellt werden",
      },
      fields: {
        birthdayDate: "Geburtsdatum",
        companyCity: "Stadt",
        companyHouseNumber: "Hausnummer",
        companyName: "Firma",
        companyStreet: "Straße",
        companyZipCode: "Postleitzahl",
        customerCode: "Kundennummer",
        emailAddress: "E-Mail-Adresse",
        firstName: "Vorname",
        isMarketingConsentGranted: "Marketing Opt-In",
        lastName: "Nachname",
        name: "Name",
        optInOptions: {
          open: "Offen",
        },
        phoneNumber: "Telefonnummer (sonstige)",
        placeholder: "Platzhalter",
        primaryResponsibleMerchantUserId: "Ansprechpartner",
        role: "Position im Unternehmen",
        trade: "Branche",
        whatsappDisplayName: "WhatsApp-Name",
        whatsappPhoneNumber: "Telefonnummer",
      },
      import: {
        button: "Importieren",
        confirm:
          "Sollen alle Kontakte aus dieser Datei \"%{filename}\" importiert werden?",
        error: "Die Kontakte-Datei konnte leider nicht importiert werden. Bitte wenden " +
          "Sie sich an unseren Kundenservice unter support@flinkit.de. Fehlerursache: " +
          "%{message}",
        exportInvalidRows: "Sie können die ignorierten Zeilen <link>exportieren</link> " +
          "um sie bei Bedarf anzupassen und sie dann erneut importieren.",
        progressDialog: {
          progressMessage: "Ihre Kontakte-Datei wird importiert. Bitte geben Sie uns " +
            "einen kurzen Moment...",
          title: "Kontakte importieren",
        },
        status: {
          ignored: "%{invalidRowsCount} Zeilen wurden aufgrund folgender " +
            "Ursachen ignoriert:",
        },
        success: "%{importedMerchantCustomerUsersCount} Kontakte wurden erfolgreich " +
          "importiert oder aktualisiert.",
      },
      importRowFailureReasons: {
        EMAIL_ADDRESS_INVALID: "Die E-Mail-Adresse ist keine gültige Adresse",
        FIRST_NAME_MISSING: "Zeile hat keinen Vornamen",
        PHONE_NUMBER_DUPLICATED: "Zeile hat eine doppelte Telefonnummer",
        PHONE_NUMBER_INVALID: "Zeile hat eine ungültige Telefonnummer",
      },
      inputs: {
        isMarketingConsentGranted: {
          falseLabel: "Ohne Opt-in",
          nullLabel: "Entweder",
          trueLabel: "Mit Opt-in",
        },
      },
      lastSalesforceSync: "Zuletzt synchronisiert: %{age}",
      lastSalesforceSyncPreparing: "wird vorbereitet",
      list: {
        chooseChannel: "Wählen Sie einen Kanal:",
      },
      name: "Kontakte",
      successMessages: {
        contactGroupAdded: "Kontaktgruppen hinzugefügt",
        contactGroupRemoved: "Kontaktgruppen entfernt",
        tagAdded: "Tag hinzugefügt",
        tagRemoved: "Tag entfernt",
      },
    },
    merchant_users: {
      actions: {
        create: "Hinzufügen",
      },
      chooseLanguage: "Sprache gewählt",
      confirmDeletion: "Möchten Sie diesen Benutzer wirklich löschen?",
      customFields: {
        myFlinkitNumbers: {
          label: "Flinkit-Nummern",
        },
      },
      edit: {
        featureSettingsTitle: "Feature settings",
        title: "Profil Details",
      },
      emailNotification: {
        choices: {
          instant: {
            description: "Sobald eine neue Nachricht in Deinen Chats eingeht, erhältst " +
              "Du eine Email.",
            label: "Sofort-Benachrichtigungen in Echtzeit",
          },
          none: {
            description: "Du erhältst keine Benachrichtigungen per Email.",
            label: "Alle Benachrichtigungen ausschalten",
          },
          reminders: {
            description: "Du erhältst maximal 3 mal am Tag eine zusammenfassende Email." +
              "Sowie eine extra Email falls Dir ein Kunden-Chat zugewiesen wurde.",
            label: "3 Erinnerungen pro Tag",
          },
        },
        title: "Email-Benachrichtigungen",
      },
      errorMessages: {
        MERCHANT_USER_EMAIL_ADDRESS_ALREADY_EXISTS:
          'Es existiert bereits ein anderer Kontakt mit dieser E-Mail-Adresse',
        invalidEmailAddress: "Ungültige Emailaddresse",
      },
      fields: {
        emailAddress: "E-Mail-Adresse",
        firstName: "Vorname",
        isAdmin: "Admin",
        isOwner: "Owner",
        language: "Sprache",
        lastName: "Nachname",
        name: "Name",
      },
      import: {
        button: "Benutzer importieren",
        confirm: "Möchten Sie Benutzer aus dieser Datei \"%{filename}\" importieren?",
        success: "%{importMerchantUsersCount} Benutzer erfolgreich importiert",
      },
      name: "Benutzer",
      successMessages: {
        created: "Nutzer erfolgreich hinzugefügt",
      },
    },
    merchants: {
      actions: {
        create: "Standort erstellen",
      },
      errorMessages: {
        create: "Beim Erstellen des Standorts ist ein Fehler aufgetreten",
      },
      fields: {
        companyName: "Name Standort",
        ownerEmailAddress: "Email",
        ownerFirstName: "Vorname",
        ownerLastName: "Nachname",
        whatsappBusinessAbout: "Über das Unternehmen",
        whatsappBusinessAddress: "Adresse",
        whatsappBusinessDescription: "Unternehmensbeschreibung",
        whatsappBusinessEmail: "E-Mail-Adresse",
        whatsappBusinessVertical: "Geschäftszweig",
        whatsappBusinessWebsite: "Webseite",
      },
      location: "Standort",
      owner: "Owner",
      successMessages: {
        created: "Ein neuer Standort wurde erfolgreich erstellt",
      },
    },
    organization_merchant_users: {
      customFields: {
        name: {
          label: "Name",
        },
      },
      fields: {
        emailAddress: "E-Mail-Adresse",
        merchantId: "Standort",
      },
    },
    tags: {
      action: {
        create: "Neuen Tag erstellen",
      },
      confirmDeletion: "Möchten Sie dieses Tag wirklich löschen?",
      create: {
        title: "Tag erstellen",
      },
      edit: {
        title: "Tag-Details",
      },
      fields: {
        merchantCustomerUsersCount: "Zugehörige Kunden",
        name: "Tag",
      },
      name: "Tags",
    },
    whatsapp_accounts: {
      fields: {
        businessAbout: "Über das Unternehmen",
        businessAddress: "Adresse",
        businessDescription: "Unternehmensbeschreibung",
        businessEmail: "E-Mail-Adresse",
        businessWebsite: "Webseite",
        whatsappBusinessVertical: "Geschäftszweig",
      },
    },
  },
  sandboxSettings: {
    /* eslint-disable max-len */
    contactUs: {
      button: "Kontaktiere uns",
      subtitle: "Hast Du Fragen oder brauchst Du Hilfe?",
      title: "Beratung anfordern",
    },
    errorMessages: {
      'CHAT_ALREADY_OWNED_BY_ANOTHER_SANDBOX_USER': "Diese Nummer wurde bereits von einem anderen Benutzer verwendet/getestet. Bitte verwende eine andere Nummer",
    },
    featureNotAvailable: "Diese Funktion ist in der kostenlosen Testphase nicht verfügbar",
    requestConversion: {
      button: "Einrichtung starten",
      caption: "Ca 15 Minuten",
      response: "Deine Anfrage wurde erhalten. Wir melden uns bald bei Dir",
      subtitle: "Verbinde Deine Nummer und richte die Whatsapp Business API ein",
      title: "WhatsApp Business API",
    },
    testSandbox: {
      button: "Jetzt testen",
      subtitle: "Teste unseren Eingang und versende Nachrichten per Whatsapp",
      title: "Test (Sandbox)",
    },
    testSandboxDialog: {
      button: "Senden",
      fields: {
        phoneNumber: "WhatsApp-Telefonnummer",
      },
      onIncomingChatMessageNotification: "Habe eine neue Nachricht erhalten und gehe zum Chat",
      onSentChatMessage: "Bitte setze auf deinem Mobiltelefon fort.",
      sandboxCodeMessage: "Hi, verbinde mich bitte mit der Flinkit Sandbox: %{code}",
      subtitle1: "Scanne einfach den Code mit deinem Smartphone",
      subtitle2: "Oder Mobilfunknummer eingeben",
      title: "Teste Eingang und Whatsapp Versand",
    },
    /* eslint-enable max-len */
  },
  searchInbox: {
    chatsResultTitle: "Chats",
    messagesResultTitle: "Nachrichten",
    minCharactersForMessagesSearch: "Geben Sie mindestens 3 Zeichen ein",
    searchChatMessagesTitle: "Nachrichten durchsuchen",
    searchInAllChatsPlaceholder: "Suche in Chats",
    searchInThisChatPlaceholder: "Suche im Chat",
  },
  sidebar: {
    campaigns: "Kampagnen",
    contacts: "Kontakte",
    help: "Hilfe",
    inbox: "Eingang",
    menu: {
      logout: "Abmelden",
    },
    profile: {
      sandboxAccount: "Testkonto",
    },
    teamChat: "Teamchat",
    templates: "Templates",
  },
  statuses: {
    pending: "Ausstehend",
  },
  validations: {
    alphanumeric: "Only alphanumeric characters are allowed",
    companyName: "Firmenname ist erforderlich“",
    companySize: "Unternehmensgröße ist erforderlich",
    date: "Ungültiges Datum",
    emailAddress: "Ungültige Emailaddresse",
    emojisNotAllowed: "Emojis sind nicht erlaubt",
    files: {
      maxCombinedSize: "Die Gesamtgröße der ausgewählten Dateien (%{combinedSize}MiB) " +
        "überschreitet unser Limit für die Gesamtdateigröße in %{maxCombinedSize}MiB",
      maxSize: "Die ausgewählte Dateigröße %{filename} (%{fileSize}MiB) überschreitet " +
        "unsere %{maxSize}MiB-Dateigrößenbeschränkung",
      unexpectedError: "Datei %{filename} konnte nicht angehängt werden",
      unsupportedFileType: "Der Typ „%{type}“ der ausgewählten Datei „%{filename}“ " +
        "wird nicht unterstützt",
    },
    fullName: "Vollständiger Name ist erforderlich",
    industry: "Industrie ist gefragt",
    maxCharacters: "Zu lang (Max. %{max} Zeichen)",
    password: {
      digit: "Mindestens eine Nummer",
      doNotMatch: "Passwort und Passwortbestätigung stimmen nicht überein",
      length: "Mindestens 8 Zeichen",
      lowercase: "Mindestens ein Kleinbuchstabe",
      missingSomeChars: "Stelle sicher, dass dein Passwort folgende Kriterien erfüllt",
      required: "Passwort wird benötigt",
      uppercase: "Mindestens ein Großbuchstabe",
    },
    phoneNumber: "Ungültige Telefonnummer",
    required: "Erforderlich",
    time: "Ungültige Zeit",
    websiteHttpsUrl: "Die Website-URL muss mit \"https://\" beginnen.",
    websiteUrl: "Geben Sie eine gültige Website-URL ein",
  },
  weekdays: {
    full: {
      friday: "Freitag",
      monday: "Montag",
      saturday: "Samstag",
      sunday: "Sonntag",
      thursday: "Donnerstag",
      tuesday: "Dienstag",
      wednesday: "Mittwoch",
    },
    shortened: {
      friday: "Fr",
      monday: "Mo",
      saturday: "Sa",
      sunday: "So",
      thursday: "Do",
      tuesday: "Di",
      wednesday: "Mi",
    },
  },
  whatsapp_business_verticals: {
    APPAREL: "Bekleidung",
    AUTO: "Autoservice",
    BEAUTY: "Beauty, Kosmetik und Körperpflege",
    EDU: "Bildungswesen",
    ENTERTAIN: "Kunst und Unterhaltung",
    EVENT_PLAN: "Veranstaltungsplaner/in",
    FINANCE: "Finanzwesen",
    GOVT: "Öffentlicher Dienst",
    GROCERY: "Lebensmittelgeschäft",
    HEALTH: "Medizin und Gesundheit",
    HOTEL: "Hotel",
    NONPROFIT: "Gemeinnützige Organisation",
    NOT_A_BIZ: "Kein Geschäft",
    OTHER: "Anderes Gewerbe",
    PROF_SERVICES: "Professionelle Dienstleistung",
    RESTAURANT: "Restaurant",
    RETAIL: "Einzelhandel",
    TRAVEL: "Reisen und Verkehr",
    UNDEFINED: "Nicht definiert",
  },
  whatsapp_message_templates: {
    statusDescriptions: {
      APPROVED: "Dieses Template kann nun in den Chats verwendet werden.",
      /* eslint-disable max-len */
      CREATED: "WhatsApp muss dieses Template noch freigeben. Erst danach kannst du es verwenden.",
      DELETED: "Dieses Template steht nicht mehr zur Verfügung",
      /* eslint-disable max-len */
      PENDING: "WhatsApp muss dieses Template noch freigeben. Erst danach kannst du es verwenden.",
      /* eslint-enable max-len */
      REJECTED: "WhatsApp hat dieses Template abgelehnt.",
    },
    statusLabels: {
      APPROVED: "Freigegeben",
      CREATED: "Warte auf Freigabe",
      DELETED: "Gelöscht",
      PENDING: "Warte auf Freigabe",
      REJECTED: "Abgelehnt",
    },
  },
  whatsapp_messages: {
    lastSendAttemptErrorCode: {
      2: "WhatsApp-Dienst vorübergehend nicht verfügbar aufgrund von Ausfallzeiten " +
        "oder Überlastung.",
      368: "Vorübergehend gesperrt aufgrund von Verstößen gegen die Richtlinien",
      410: (
        "Das Verfallsdatum wurde erreicht bevor die Nachricht versandt werden konnte"
      ),
      429: "Sie haben zu viele Nachrichten in sehr kurzer Zeit versandt",
      471: "Zu viele Ihrer Nachrichten wurden als Spam gemeldet",
      480: "Diese WhatsApp Nummer hat vermutlich einen neuen Besitzer",
      1001: "Die Nachricht ist länger als die erlaubten 4096 Zeichen",
      1009: "Die Nachricht enthält ungültige Attribute",
      1013: "Diese Telefonnummer hat noch kein WhatsApp eingerichtet",
      1026: "Der Empfänger kann diese Nachricht nicht empfangen",
      1028: "Diese WhatsApp Nummer hat vermutlich einen neuen Besitzer",
      2003: "Der Empfänger konnte das Nachrichten-Template nicht empfangen",
      2008: "Das Format des Dateianhangs wird nicht von WhatsApp unterstützt",
      80007: "Das WhatsApp Business-Konto hat sein Rate-Limit erreicht.",
      131026: "Nachricht kann nicht zugestellt werden. Die Telefonnummer des " +
        "Empfängers ist keine WhatsApp-Telefonnummer oder hat unsere neuen " +
        "Nutzungsbedingungen nicht akzeptiert oder verwendet eine alte WhatsApp-Version.",
      131031: "Konto wurde gesperrt",
      131048: "Spam-Rate-Limit erreicht",
      131053: "Es ist nicht möglich, das in der Nachricht verwendete Medium hochzuladen.",
      131056: "(Business Account, Consumer Account) Paar-Rate-Limit erreicht. Bitte " +
        "warten und erneut versuchen, die Nachricht an diesen Empfänger zu senden.",
      MESSAGE_SEND_TIMEOUT: "Die Nachricht konnte nicht gesendet werden",
      TEMPLATE_REJECTED: "Das Template wurde abgelehnt",
    },
    lastSendAttemptErrorCodeToCustomDetails: {
      MESSAGE_SEND_TIMEOUT: "Die Genehmigung dieser Nachrichtenvorlage durch Meta hat" +
        " zu lange gedauert",
      TEMPLATE_REJECTED: "Deine Nachricht konnte nicht verschickt werden, versuche es " +
        "erneut mit anderem Inhalt, oder verschicke ein Template",
    },
    receivingErrorCode: {
      501: "Nicht unterstützter Nachrichtentyp",
    },
  },
  whatsappAccountBusinessProfileEdit: {
    profilePhotoConstraints: "Empfohlene Dateigröße, 5 KB bis 5 MB. PNG, JPG",
    successfulProfilePhotoUpload: "Profilfoto erfolgreich aktualisiert",
    validations: {
      emailAddress: "Ungültige Emailaddresse",
      profilePhotoSize: "Bitte nutzen Sie das empfohlene Format bzw. die empfohlene " +
        "Größe!",
      websiteUrl: "Die URL der Website muss entweder mit http:// oder https:// beginnen.",
    },
  },
}
